import { getStartingPoint } from './project-finder-model.mjs';

export const HANDOFF_KEY = 'skai.project-starting-point.v1';
export const HANDOFF_TTL = 30 * 60 * 1000;

// Only validated project choices are stored, never contact details or free text.
export function saveProjectHandoff(storage, answers, now = Date.now()) {
  try {
    if (!answers || typeof answers !== 'object' || !getStartingPoint(answers) || !Number.isFinite(now)) return false;
    const payload = { version: 1, at: now, answers: { type: answers.type, goal: answers.goal, stage: answers.stage } };
    storage.setItem(HANDOFF_KEY, JSON.stringify(payload)); return true;
  } catch { return false; }
}

export function clearProjectHandoff(storage) {
  try { storage.removeItem(HANDOFF_KEY); } catch { /* Storage may be disabled. */ }
}

export function readProjectHandoff(storage, now = Date.now()) {
  try {
    const raw = storage.getItem(HANDOFF_KEY);
    if (!raw) return null;
    const data = JSON.parse(raw);
    if (!data || data.version !== 1 || !Number.isFinite(data.at) || !Number.isFinite(now) || data.at > now || now - data.at > HANDOFF_TTL || !data.answers || typeof data.answers !== 'object') throw new Error('Invalid handoff');
    const result = getStartingPoint(data.answers);
    if (!result) throw new Error('Invalid choices');
    return result;
  } catch { clearProjectHandoff(storage); return null; }
}

export function browserSessionStorage() {
  try { return window.sessionStorage; } catch { return null; }
}
